import { gql } from 'apollo-boost';


export const GET_PROJECTS = gql`
    query getProjects($year: String, $type: String, $program: String) {
        projects(year: $year, type: $type, program: $program) {
            uid
            type
            date
            title
            description
            year
            project {
                type
                program
                location
                external
                thumbnail {
                    url
                }
            }
        }
    } 
`;

export const GET_PROJECT = gql`
    query getProject($uid: String!, $year: String, $type: String, $program: String) {
        project(uid: $uid, year: $year, type: $type, program: $program) {
            post {
                uid
                type
                date
                title
                description
                year
                project {
                    type
                    program
                    location
                    external
                }
                media {
                    type
                    url
                }
            }
            nextUid
        }
    }
`;

/*
export const GET_PROJECT = gql`
    query getProject($uid: String!) {
        post(uid: $uid) {
            uid
            type
            date
            title
            description
            year
            project {
                type
                program
                selected
                location
                external
            }
            media {
                type
                url
            }
        }
    }
`;
*/